module.exports = __webpack_public_path__ + "img/w3_outlet_light.da50d50e.png";